import { render, staticRenderFns } from "./EditFactTypeColumn.vue?vue&type=template&id=0406c2a6&"
import script from "./EditFactTypeColumn.vue?vue&type=script&lang=js&"
export * from "./EditFactTypeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports